<template>
 <svg role="img" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none" aria-label="A magnifying glass icon">
  <path
   fill-rule="evenodd"
   clip-rule="evenodd"
   d="M13.5 7.5C13.5 10.5376 11.0376 13 8 13C4.96243 13 2.5 10.5376 2.5 7.5C2.5 4.46243 4.96243 2 8 2C11.0376 2 13.5 4.46243 13.5 7.5ZM12.8266 13.2408C11.5222 14.3386 9.83833 15 8 15C3.85786 15 0.5 11.6421 0.5 7.5C0.5 3.35786 3.85786 0 8 0C12.1421 0 15.5 3.35786 15.5 7.5C15.5 9.08208 15.0101 10.5498 14.1738 11.7596L18.7071 16.2929C19.0976 16.6834 19.0976 17.3166 18.7071 17.7071C18.3166 18.0976 17.6834 18.0976 17.2929 17.7071L12.8266 13.2408Z"
   fill="currentColor"
  />
 </svg>
</template>
